module.exports = __webpack_public_path__ + "static/img/1.2a90915.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/1.png
// module id = Rq+T
// module chunks = 0